import styled from "styled-components/macro";
import backgroudPresale from "../../img/backgroudPreSale.png";
import backgroudPresaleDesktop from "../../img/backgroundPresaleDesktop.png";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  height: 400px;
  background-image: url(${backgroudPresale});
  background-repeat: no-repeat;
  background-size: cover;
  mix-blend-mode: multiply;

  h1 {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 600;
    font-size: 29px;
    line-height: 38px;
    color: #ffffff;
    margin: 0;
    text-align: center;
  }
  p {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    color: #ffffff;
    padding-bottom: 1.5rem;
    padding: 0.5rem 2rem;
  }
  @media (min-width: 992px) {
    background-image: url(${backgroudPresaleDesktop});
    background-color: linear-gradient(
      137.89deg,
      rgba(0, 0, 0, 0.8) 42.14%,
      rgba(128, 102, 111, 0.8) 99.84%
    ) !important;
    h1 {
      font-size: 40px;
      line-height: 47px;
    }
    p {
      font-size: 18px;
      line-height: 24px;
      padding: 0 28rem;
      padding-bottom: 1.5rem;
    }
  }
`;
export const Button = styled.a`
  cursor: pointer;
  width: 220px;
  height: ${({ lenguageCss }) => (lenguageCss === "por" ? "40px" : "30px")};
  background: #ffffff;
  border-radius: 18px;
  border: none;
  text-decoration: none;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #000000;
  text-decoration: none;
  text-align: center;
  padding-top: 0.5rem;

  @media (min-width: 992px) {
    width: 300px;

    font-size: 19px;
    line-height: 19px;
    font-weight: 500;
    padding: 0.5rem 0.5rem 0 0.5rem;
  }
`;
